import { Component, Input } from '@angular/core';
import { defaultDisplayAttributes } from '../../../../core/models/default-display-attributes.const';
import { IFilterData } from '../../../../core/models/filter-data.model';
import { IProduct } from '../../../../core/models/product.model';
import { IDisplayMetric } from '../../../../core/models/display-metric.model';

@Component({
    selector: 'lynkd-pattern-gallery-listing-caption',
    templateUrl: './gallery-listing-caption.component.html',
    styleUrls: ['./gallery-listing-caption.component.scss']
})
export class GalleryListingCaptionComponent {
    @Input()
    public filterData: IFilterData = {
        display_attributes: defaultDisplayAttributes
    };

    @Input()
    public metricStyle: Record<string, string>;

    @Input()
    public product: IProduct;

    /**
     * Renders display metrics in the order they arrive -- no re-ordering here.
     *
     * Rank ordering is applied once, at boot, by setDefaultDisplayMetrics() walking the
     * rank-sorted catalogue from getProductMetrics(). Re-applying galleryRank at render time
     * hoisted every default metric back to the front of the caption on each change-detection
     * pass, so a user's own selection order was discarded the moment it included a default.
     * It also sorted in place, mutating the listing component's own display_metrics array
     * (inputs.display_metrics shares the reference), which leaked the rank order into
     * currentBoard.fields and back into the metric picker on reopen.
     */
    public get displayMetrics(): Array<IDisplayMetric> {
        return this.filterData?.display_metrics ?? [];
    }
}
